import { createFileRoute } from "@tanstack/react-router";

import { fetchPoliciesIndex } from "@/loaders/policies";
import Policies from "@/pages/policies";

export const Route = createFileRoute("/policies/$company/$location/")({
  component: PoliciesPage,
  head: ({ loaderData }) => {
    if (!loaderData) {
      return {};
    }
    return { meta: [{ title: loaderData.title }] };
  },
  loader: ({ params }) =>
    fetchPoliciesIndex({
      data: { company: params.company, location: params.location },
    }),
});

function PoliciesPage() {
  const data = Route.useLoaderData();
  return <Policies {...data} />;
}
